import { type ResolutionString } from 'charting_library';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import utc from 'dayjs/plugin/utc';

import { timeframeToMilliseconds } from '../timeframe-to-milliseconds';

dayjs.extend(utc);
dayjs.extend(isoWeek);

export const getTimeRangeOfTickByTimeframe = ({
  tickTimestamp,
  timeframe,
}: {
  tickTimestamp: number;
  timeframe: ResolutionString;
}): { start: number; end: number } | undefined => {
  const timeframeInMilliseconds = timeframeToMilliseconds(timeframe);

  if (!timeframeInMilliseconds) return;

  if (timeframe.includes('M')) {
    const start = dayjs(tickTimestamp).utc().startOf('month').valueOf();
    const end = dayjs(start).add(parseInt(timeframe), 'month').valueOf() - 1;

    return {
      start,
      end,
    };
  }

  if (timeframe.includes('W')) {
    const start = dayjs(tickTimestamp).utc().startOf('isoWeek').valueOf();
    const end = start + timeframeInMilliseconds - 1;

    return {
      start,
      end,
    };
  }

  const start = Math.floor(tickTimestamp / timeframeInMilliseconds) * timeframeInMilliseconds;
  const end = start + timeframeInMilliseconds - 1;

  return {
    start,
    end,
  };
};
